/**
 * Model used for news and news-articles
 * @param {number} id - The ID. Should be used in the URL if readableUrl is not set.
 * @param {string?} title - The Title.
 * @param {string?} readableUrl - The readable URL if set in backend.
 * @param {Date} publishDate - The date the article was published.
 * @param {Thumbnail[]?} thumbnails - Thumbnail in various resolutions.
 * @param {ArticleStrip[]?} strips - List of Article strips...
 */
var Article = /** @class */ (function () {
    function Article() {
    }
    Article.createFromApi = function (dto) {
        var _a;
        return Object.assign(new Article(), dto, {
            strips: (_a = dto.strips) === null || _a === void 0 ? void 0 : _a.map(function (x) { return Strip.createFromApi(x); })
        });
    };
    return Article;
}());
export { Article };
var Strip = /** @class */ (function () {
    function Strip() {
    }
    Strip.createFromApi = function (dto) {
        return Object.assign(new Strip(), dto, {});
    };
    return Strip;
}());
export { Strip };
